module.exports = __webpack_public_path__ + "img/news.6c574a6e.svg";